import React from 'react';
import TierRateField from '../TierRateField';
import planningEditHelper from '../../../Helpers/planningEditHelper';
import FieldworkPeriodGrid from '../FieldworkPeriodGrid';
import FieldworkPeriodDateGrid from '../FieldworkPeriodDateGrid';
import CountryPlanningGrid from '../CountryPlanningGrid';

export const renderTargetRateField = (props) => (
  <TierRateField
    values={props.value}
    disabled={typeof props.disabled === 'function' ? props.disabled(props.editedItem) : props.disabled}
    onSet={(tier, rawValue) =>
      props.onChange(props.fieldName, planningEditHelper.balanceRateArray(props.value, tier, rawValue))
    }
  />
);

export const renderFieldworkPeriodGrid = (props) => (
  <FieldworkPeriodGrid
    value={props.value}
    onChange={(newValue) => props.onChange(props.fieldName, newValue)}
  />
);

export const renderFieldworkPeriodDateGrid = (props) => (
  <FieldworkPeriodDateGrid
    value={props.value}
    editedItem={props.editedItem}
    onChange={(newValue) => props.onChange(props.fieldName, newValue)}
  />
);

export const renderCountryPlanningGrid = (props) => (
  <CountryPlanningGrid
    value={props.value}
    onChange={(newValue) => props.onChange(props.fieldName, newValue)}
  />
);
